import { c as _c } from "react/compiler-runtime";
import React, { forwardRef } from 'react';
import { StyledProgress } from './Styles';
import { type ProgressProps } from './Types';
import { LinearProgress } from '@mui/material';
export const Progress = forwardRef<HTMLDivElement, ProgressProps>((t0, ref) => {
  const $ = _c(16);
  let indicatorColor;
  let props;
  let t1;
  let t2;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      variant: t1,
      indicatorColor,
      orientation: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = indicatorColor;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = value;
  } else {
    indicatorColor = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    value = $[5];
  }
  const variant = t1 === undefined ? "determinate" : t1;
  const orientation = t2 === undefined ? "horizontal" : t2;
  const errorColorValue = value >= 0 && value <= 25;
  const warningColorValue = value >= 26 && value <= 50;
  const progressColorIndicator = errorColorValue ? "error" : warningColorValue ? "warning" : "success";
  const t3 = indicatorColor ?? progressColorIndicator;
  let t4;
  if ($[6] !== value || $[7] !== variant) {
    t4 = <LinearProgress variant={variant} value={value} />;
    $[6] = value;
    $[7] = variant;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== orientation || $[10] !== props || $[11] !== ref || $[12] !== t3 || $[13] !== t4 || $[14] !== value) {
    t5 = <StyledProgress orientation={orientation} value={value} $indicatorColor={t3} {...props} ref={ref}>{t4}</StyledProgress>;
    $[9] = orientation;
    $[10] = props;
    $[11] = ref;
    $[12] = t3;
    $[13] = t4;
    $[14] = value;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
});
export default Progress;